export default __webpack_public_path__ + "static/media/get-started-aws.b04ed1d2.svg";